<template>
  <v-card class="my-1 elevation-0" style="height: 100%;">
    <v-card-title>
      <h5>Top 10 - PSFP</h5>
    </v-card-title>
    <div
      v-if="loading"
      class="d-flex align-center justify-center"
      style="height: 300px;"
    >
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <v-card-text v-else>
      <v-data-table
        :headers="[
          { text: '#', value: 'index', width: '50px', sortable: false },
          {
            text: 'Índice',
            value: 'indice_categoria',
            align: 'center',
            sortable: false,
          },
          { text: 'Serviço', value: 'servico', sortable: false },
          { text: 'PSFP', value: 'psfp', align: 'center', sortable: false },
          { text: 'SA', value: 'sa', align: 'center', sortable: false },
          { text: 'SFP', value: 'sfp', align: 'center', sortable: false },
        ]"
        :items="topPsfp.slice(0, 10).map((d, i) => ({ ...d, index: i + 1 }))"
        hide-default-footer
        disable-pagination
        @click:row="onRowClick"
        :item-class="() => 'cursor-pointer'"
        style="cursor: pointer;"
      >
        <template v-slot:item.index="{ item }">
          {{ item.index }}
        </template>
        <template v-slot:item.indice_categoria="{ item }">
          {{ item.indice_categoria }}
        </template>
        <template v-slot:item.servico="{ item }">
          <div>
            <strong>{{ item.codigos_servico }}</strong>
            <v-tooltip v-if="Number(item.sa) <= 10" right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="warning" class="ml-1">
                  mdi-alert
                </v-icon>
              </template>
              <span
                >PSFP alto com volume baixo (SA ≤ 10) — possível efeito
                denominador.</span
              >
            </v-tooltip>
          </div>
          <div style="font-size: 12px; color: #888;">
            {{ item.descricao_por_indice }}
          </div>
        </template>
        <template v-slot:item.psfp="{ item }">
          <span
            v-if="item.psfp !== null && item.psfp !== undefined"
            :style="{ color: getCorPsfp(item.faixa_chave), fontWeight: 'bold' }"
          >
            {{ item.psfp | parseNumberToFloatBrIgnoringNaN }}%
          </span>
          <span
            v-else
            :style="{ color: getCorPsfp(item.faixa_chave), fontWeight: 'bold' }"
          >
            —
          </span>
        </template>
        <template v-slot:item.sa="{ item }">
          {{ item.sa | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:item.sfp="{ item }">
          {{ item.sfp | parseNumberToFloatBrIgnoringNaN }}
        </template>

        <template v-slot:header.sa="{ header }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs" class="text-no-wrap">
                {{ header.text }}
                <v-icon x-small color="grey">mdi-help-circle-outline</v-icon>
              </span>
            </template>
            <span>
              Sa = quantidade de serviços executados pela distribuidora em cada
              categoria de serviço comercial <i>i</i>.
            </span>
          </v-tooltip>
        </template>

        <template v-slot:header.sfp="{ header }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs" class="text-no-wrap">
                {{ header.text }}
                <v-icon x-small color="grey">mdi-help-circle-outline</v-icon>
              </span>
            </template>
            <span>
              SFP = quantidade de serviços executados pela distribuidora, fora
              do prazo regulatório, em cada categoria de serviço comercial
              <i>i</i>.
            </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "DashboardIsfpPsfpTop10PsfpGeral",
  props: {
    topPsfp: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  methods: {
    getCorPsfp(faixaChave) {
      const cores = {
        ate_1: "#4CAF50",
        de_1_a_5: "#8BC34A",
        de_5_a_10: "#FFC107",
        de_10_a_20: "#FF9800",
        acima_20: "#F44336",
      };
      return cores[faixaChave] || "#000";
    },
    onRowClick(item) {
      const primeiroCodigo = item.codigos_servico
        ? parseInt(item.codigos_servico.split(",")[0].trim())
        : null;
      this.$emit("servicoSelecionado", primeiroCodigo);
    },
  },
};
</script>
